import React from 'react';

export default function ActionPromptModal({
  open,
  title,
  description,
  inputType = 'text',
  value = '',
  placeholder = '',
  submitLabel = 'Confirm',
  cancelLabel = 'Cancel',
  loading = false,
  onChange,
  onCancel,
  onSubmit,
}) {
  if (!open) return null;

  const isTextarea = inputType === 'textarea';
  const isNumber = inputType === 'number';
  const shouldRenderInput = inputType !== 'none';

  return (
    <div className="fixed inset-0 z-[2100] bg-black/60 p-4 flex items-center justify-center">
      <div className="w-full max-w-md rounded-xl border border-slate-700 bg-slate-900 p-4">
        <h3 className="text-lg font-bold text-slate-100">{title || 'Confirm'}</h3>
        {description ? <p className="mt-1 text-sm text-slate-300">{description}</p> : null}

        {shouldRenderInput ? (
          <div className="mt-3">
            {isTextarea ? (
              <textarea
                value={value}
                onChange={(e) => onChange?.(e.target.value)}
                rows={4}
                className="w-full rounded-lg bg-slate-800 border border-slate-700 px-3 py-2 text-slate-100"
                placeholder={placeholder}
                autoFocus
              />
            ) : (
              <input
                type={isNumber ? 'number' : 'text'}
                value={value}
                onChange={(e) => onChange?.(e.target.value)}
                className="w-full rounded-lg bg-slate-800 border border-slate-700 px-3 py-2 text-slate-100"
                placeholder={placeholder}
                autoFocus
                inputMode={isNumber ? 'numeric' : undefined}
              />
            )}
          </div>
        ) : null}

        <div className="mt-4 flex gap-2">
          <button
            onClick={onCancel}
            disabled={loading}
            className="flex-1 rounded-lg bg-slate-700 hover:bg-slate-600 text-slate-100 py-2 font-semibold disabled:opacity-60"
          >
            {cancelLabel}
          </button>
          <button
            onClick={onSubmit}
            disabled={loading}
            className="flex-1 rounded-lg bg-cyan-700 hover:bg-cyan-600 text-white py-2 font-semibold disabled:opacity-60"
          >
            {loading ? 'Working…' : submitLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
